import React from "react";
import { useLanguage } from "../../context/LanguageContext";

const Footer = () => {
  const { t } = useLanguage();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-black border-t border-white/5"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-20 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-3" data-testid="footer-logo">
              <span className="w-10 h-10 border border-[#e8d4a8]/60 flex items-center justify-center shrink-0">
                <span className="font-display text-[#e8d4a8] text-[11px] tracking-[0.15em] leading-none">
                  NMN
                </span>
              </span>
              <span className="flex flex-col leading-tight">
                <span className="font-display text-[16px] tracking-wide text-white">
                  NMN <span className="text-[#e8d4a8]">Energy Consulting</span>
                </span>
                <span className="font-mono-l text-[9px] text-white/45 mt-1">
                  {t.brand.subtitle}
                </span>
              </span>
            </a>
            <p className="mt-6 text-white/50 text-sm font-light max-w-sm leading-relaxed">
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono-l text-[10px] text-white/40 mb-5">
              {t.nav.locations}
            </div>
            <ul className="space-y-3 text-white/70 text-sm">
              <li>{t.locations.cyprus.name}</li>
              <li>{t.locations.turkey.name}</li>
              <li>{t.locations.uae.name}</li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-mono-l text-[10px] text-white/40 mb-5">
              {t.nav.contact}
            </div>
            <ul className="space-y-3 text-white/70 text-sm">
              <li>
                <a
                  href="tel:+905488267252"
                  className="hover:text-[#e8d4a8] transition-colors"
                  data-testid="footer-phone"
                >
                  +90 548 826 72 52
                </a>
              </li>
              <li>
                <a
                  href="mailto:gufenerb@gmail.com"
                  className="hover:text-[#e8d4a8] transition-colors"
                  data-testid="footer-email"
                >
                  gufenerb@gmail.com
                </a>
              </li>
              <li>
                <a
                  href="https://t.me/nmn_energy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#e8d4a8] transition-colors"
                  data-testid="footer-telegram"
                >
                  @nmn_energy
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <p className="font-mono-l text-[10px] text-white/40">
            © {year} NMN Energy Consulting — {t.footer.rights}
          </p>
          <p className="font-mono-l text-[10px] text-white/40">
            {t.footer.regions}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
